import React from 'react'
import Form from 'react-bootstrap/Form';
import './leaveFeedback.scss'
import { Button } from 'react-bootstrap'
import { StarOutline } from '../Icons'

const LeaveFeedback = () => {
    return (
        <>
            <div className='feedback-wrapper-outer'>
                <div className='section-heading'>Leave feedback about this</div>
                <div className='feedback-wrapper'>
                    <div className='feedback-rating-wrap'>
                        <div className='feedback-rating-title'>Rating</div>
                        <div className='feedback-rating'> <StarOutline />  <StarOutline />  <StarOutline />  <StarOutline /> <StarOutline /></div>
                    </div>
                    <div className='w-100'>
                        <Form.Label>Write a Review</Form.Label>
                        <Form.Control as="textarea" rows={4}  placeholder='Describe job details'/>

                    </div>
                    <div className='w-100 feeback-btn-wrap'>
                        <Button variant='primary' type='submit'>Submit Review</Button>
                    </div>
                </div>
            </div>

        </>
    )
}

export default LeaveFeedback
